export default __webpack_public_path__ + "static/media/uploader-insuletOmnipod-4.684f4a48.png";